import CeWebsiteEmbedLayout from '/@/modules/cewebsite/pages/CeWebsiteEmbedLayout.vue';
import { TaxRoute } from '/@/modules/tax/routes/tax.routes';

export const router = [
  {
    path: '/',
    name: 'probatetaxcalculator',
    component: () => import('/@/modules/cewebsite/pages/CeWebsiteLayout.vue'),
    children: [
      {
        path: `/${TaxRoute.PROBATE_TAX_CALCULATOR.name}`,
        name: TaxRoute.PROBATE_TAX_CALCULATOR.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/ontario/ProbateTaxCalculatorPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.CALIFORNIA_PROBATE_CALCULATOR.name}`,
        name: TaxRoute.CALIFORNIA_PROBATE_CALCULATOR.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/california/CaliforniaProbateCalculatorPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.CALIFORNIA_BOND_CALCULATOR.name}`,
        name: TaxRoute.CALIFORNIA_BOND_CALCULATOR.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/california/CaliforniaBondCalculatorPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.BRITISH_COLUMBIA_PROBATE_CALCULATOR.name}`,
        name: TaxRoute.BRITISH_COLUMBIA_PROBATE_CALCULATOR.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/britishcolumbia/BritishColumbiaProbateCalculatorPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.PROBATE_TAX_REPORT.name}`,
        name: TaxRoute.PROBATE_TAX_REPORT.path,
        component: () => import('/@/modules/tax/pages/ProbateTaxReportPage.vue'),
        meta: { authOnly: false }
      }
    ]
  },
  {
    path: '/',
    name: 'probatetaxcalculatorembed',
    component: CeWebsiteEmbedLayout,
    children: [
      {
        path: `/${TaxRoute.PROBATE_TAX_CALCULATOR_EMBED.name}`,
        name: TaxRoute.PROBATE_TAX_CALCULATOR_EMBED.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/ontario/ProbateTaxCalculatorEmbedPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.CALIFORNIA_PROBATE_CALCULATOR_EMBED.name}`,
        name: TaxRoute.CALIFORNIA_PROBATE_CALCULATOR_EMBED.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/california/CaliforniaProbateCalculatorEmbedPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.CALIFORNIA_BOND_CALCULATOR_EMBED.name}`,
        name: TaxRoute.CALIFORNIA_BOND_CALCULATOR_EMBED.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/california/CaliforniaBondCalculatorEmbedPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.BRITISH_COLUMBIA_PROBATE_CALCULATOR_EMBED.name}`,
        name: TaxRoute.BRITISH_COLUMBIA_PROBATE_CALCULATOR_EMBED.path,
        component: () =>
          import(
            '/@/modules/tax/pages/calculators/jurisdictions/britishcolumbia/BritishColumbiaProbateCalculatorEmbedPage.vue'
          ),
        meta: { authOnly: false }
      },
      {
        path: `/${TaxRoute.PROBATE_TAX_REPORT_EMBED.name}`,
        name: TaxRoute.PROBATE_TAX_REPORT_EMBED.path,
        component: () => import('/@/modules/tax/pages/ProbateTaxReportPage.vue'),
        meta: { authOnly: false }
      }
    ]
  }
];
